import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpdeskService } from '../../services/delavci/helpdesk.service';
import { LoginPartnerService } from '../../services/partner/login-partner/login-partner.service';
import { MainService } from '../../services/delavci/main.service';
import { Partner } from '../../models/Partner';

@Component({
  selector: 'app-mail-token',
  templateUrl: './mail-token.component.html',
  styleUrls: ['./mail-token.component.css']
})
export class MailTokenComponent implements OnInit {

  public id;
  public token;
  public spinner = true;
  public error = false;
  public checkPartner: Partner;
  constructor(private router: Router, private route: ActivatedRoute, private mainService: MainService,
              private helpdeskService: HelpdeskService, private loginPartnerService: LoginPartnerService) { }

  ngOnInit() {
   // this.id = this.route.snapshot.params.id;
    //this.token = this.route.snapshot.params.token;
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (this.mainService.currentUserValue) {
      this.mainService.logout();
      window.location.reload();
    }
    if (this.loginPartnerService.currentPartnerValue ) {
      this.loginPartnerService.logout();
      window.location.reload();
    } else {
      this.loginPartner();
    }
  }

  redirectToTask() {
    this.helpdeskService.getOneHelpdeskRow(this.loginPartnerService.currentPartnerValue.sessionUser, null,
      this.loginPartnerService.currentPartnerValue, this.id).subscribe( data => {
        this.spinner = false;
        this.helpdeskService.changeDataRow(data.data.tasks[0]);
        this.router.navigate(['/uredi-task/' + this.id], { queryParams: { zavihek: 'description'} });

      }, error => {
        console.log(error);
      });
  }

  loginPartner() {
    this.loginPartnerService.getSession().subscribe( data => {
      this.loginPartnerService.loginPartnerWithToken(data.data.sessionUser, this.token).subscribe( data => {
        this.checkPartner = data.data;
        if(this.checkPartner.id != null){
          this.loginPartnerService.setCurrentPartner(data.data);
        }
        if (this.loginPartnerService.currentPartnerValue != null) {
          this.redirectToTask();
        } else {
          this.router.navigate(['/login-partner']);
        }
      }, error => {
        console.log(error);
      });
    }, error => {
      console.log(error);
    });

  }
}
